import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import './Workshop.css';
import ProgramCard from '../../Program/components/ProgramCard';

export default class Workshops extends React.PureComponent {
    componentDidMount() {
        window.scrollTo(0, 0);
        // this.props.loadWorkshopProgram();
    }

    onWorkshopClick = itemId => () => this.props.pushAction(`/workshops/${itemId}`);

    renderProgramRow = row => {
        const slots = Object.keys(row.statusOfTalks).sort();

        return slots.map(track => {
            const status = row.statusOfTalks[track];
            const talks = [];
            if (row.talks[track]) {
                row.talks[track].forEach(talkId => {
                    if (this.props.talksById[talkId]) {
                        talks.push(this.props.talksById[talkId]);
                    }
                });
            }
            const talk = talks[0] || {};
            const speakers = {};
            if (Object.keys(this.props.speakersById).length > 0 && talks[0]) {
                talks.forEach(item => {
                    speakers[item.id] = [];
                    item.speakers.forEach(speakerId => {
                        if (this.props.speakersById[speakerId]) {
                            speakers[item.id].push(this.props.speakersById[speakerId].name);
                        }
                    });
                });
            }

            return (
                <ProgramCard
                    id={talk.id || ''}
                    key={track}
                    onClickHandler={this.onWorkshopClick}
                    room={talk.room || row.roomsInSlots[track] || ''}
                    screen="program"
                    speakers={speakers || {}}
                    talks={talks || []}
                    tileRole={status}
                    time={row.time}
                    track=""
                />
            );
        });
    };

    renderWorkshopProgram = () => {
        const timeslots = orderBy(
            Object.values(this.props.workshopTimeSlotsById),
            ['time'],
            ['asc']
        );
        if (timeslots.length > 0) {
            return timeslots.map(slot => (
                <div className="columns is-variable is-mobile is-multiline is-1" key={slot.time}>
                    <div className="column is-1-desktop is-hidden-touch time-box">{slot.time}</div>
                    {this.renderProgramRow(slot)}
                </div>
            ));
        }
        return <span>There is no workshop program at this time...</span>;
    };

    render() {
        return (
            <section className="section" id="program-section">
                <div className="container">
                    <div className="columns is-multiline is-vcentered page-title-row">
                        <div className="column" />
                        <h1 className="column">HANDS-ON LABS</h1>
                        <span className="column program-date">
                            <i className="fas fa-calendar-alt" /> Thursday, October, 17
                        </span>
                    </div>
                    <div className="workshop-info">
                        To register to the Hands-on Labs, you will need to modify your existing
                        OpenSlava conference registration.
                    </div>
                    {!this.props.fetchingProgram ? (
                        this.renderWorkshopProgram()
                    ) : (
                        <i
                            className="fa fa-spinner fa-spin fa-3x fa-fw"
                            style={{ color: '#7500c0' }}
                        />
                    )}
                </div>
            </section>
        );
    }
}

Workshops.propTypes = {
    fetchingProgram: PropTypes.bool.isRequired,
    pushAction: PropTypes.func.isRequired,
    speakersById: PropTypes.objectOf(PropTypes.any).isRequired,
    talksById: PropTypes.objectOf(PropTypes.any).isRequired,
    workshopTimeSlotsById: PropTypes.objectOf(PropTypes.any).isRequired
};
